import Link from "next/link";
import React from "react";

export default function GradientButton({
  text,
  href,
  textSize,
  isRounded = true,
  tabIndex,
  "aria-hidden": ariaHidden,
}: {
  text: string;
  href: string;
  textSize: string;
  isRounded?: boolean;
  tabIndex?: number;
  "aria-hidden"?: boolean;
}) {
  return (
    <Link href={href} tabIndex={tabIndex} aria-hidden={ariaHidden}>
      <button
        className={`${textSize} bg-gradient-to-tr from-[#090EDB] to-[#E73DC4] hover:bg-gradient-to-tr hover:from-[#090EDB]/80 hover:to-[#E73DC4]/80 text-white font-semibold ${
          textSize === "text-xs" ? "px-4" : "px-6"
        } py-2 ${isRounded ? "rounded-lg" : ""}  active:ring-2 ring-purple-500`}
      >
        {text}
      </button>
    </Link>
  );
}
